/**
 * https://core.telegram.org/bots/webapps#safeareainset
 * https://core.telegram.org/bots/webapps#contentsafeareainset
 *
 * Created by spepa on 18.12.2024
 */

const Telegram = function () {
    Platform.call(this, connector.TELEGRAM, {
        sdk: SdkManager.SDK_TELEGRAM
    });
};

Telegram.prototype = Object.create(Platform.prototype);
Telegram.prototype.constructor = Telegram;

Telegram.prototype._initialize = function (callback) {
    this.whenConnected(() => {
        window.Telegram.WebApp.enableClosingConfirmation();
        window.Telegram.WebApp.disableVerticalSwipes();

        window.Telegram.WebApp.ready();
        window.Telegram.WebApp.expand();
        if (window.Telegram.WebApp.isVersionAtLeast("8.0")) {
            try {
                window.Telegram.WebApp.requestFullscreen();
            } catch (err) {
                console.error("Telegram requestFullscreen failed", err);
            }
        }

        // TODO: CloudStorage?
        // addToHomeScreen + checkHomeScreenStatus
    });

    callback();
};

Telegram.prototype._safePaddingSubscribe = function () {
    this.whenConnected(() => {
        window.Telegram.WebApp.onEvent("safeAreaChanged", () => {
            this._triggerSafePadding();
        });
        window.Telegram.WebApp.onEvent("contentSafeAreaChanged", () => {
            this._triggerSafePadding();
        });
    });
};

Telegram.prototype.getSafePadding = function () {
    if (!this.isConnected()) {
        return;
    }

    const safeAreaInset = window.Telegram.WebApp.safeAreaInset;
    const contentSafeAreaInset = window.Telegram.WebApp.contentSafeAreaInset;

    return {
        top: Math.max(safeAreaInset.top + contentSafeAreaInset.top - 6, 0),
        bottom: Math.max(safeAreaInset.bottom + contentSafeAreaInset.bottom - 6, 0),
        left: Math.max(safeAreaInset.left + contentSafeAreaInset.left - 6, 0),
        right: Math.max(safeAreaInset.right + contentSafeAreaInset.right - 6, 0)
    };
};

Telegram.prototype.getLocalStoragePrefix = function () {
    return "_tg";
};